import { API, Market } from "@thenounproject/lingo-core";
import { createQueryAction } from "@actions/actionCreators";

type Args = {
  spaceId: number;
  page?: number;
  limit?: number;
  sort?: string;
};

export type MarketsResult = {
  markets: Market[];
  total: number;
};

type NormalizedResult = {
  markets: number[];
  total: number;
};

const [useMarkets, fetchMarkets] = createQueryAction<Args, MarketsResult, NormalizedResult>(
  {
    entity: "markets",
    action: "fetchMarkets",
    condition: ({ args }) => Boolean(args.spaceId),
    denormalize: { entity: null, markets: "markets" },
    pagingKey: "markets",
  },
  async ({ args }) => {
    const res = await API.call<{ markets: number[]; total: number }>({
      endpoint: `spaces/${args.spaceId}/markets`,
      method: "GET",
      query: {
        page: args.page,
        limit: args.limit,
        sort: args.sort,
      },
    });
    return res;
  }
);

export default useMarkets;
export { fetchMarkets };
